import { LmgService } from "../resource";

const InsuranceModule = {
  namespaced: true,
  state: {
    datas: [],
    uppers: [],
    data: {},
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
    SET_UPPERS(state,payload){
      state.uppers = payload;
    }
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.InsuranceCreate(payload);
    },
    updateData({ commit, state }, payload) {
      return LmgService.InsuranceUpdate(payload.ID,payload);
    },
    deleteData({ commit, state }, payload) {
      return LmgService.InsuranceDelete(payload.ID,payload);
    },
   
    async listUpper({ commit, state },payload) {
      try {
        const data = await LmgService.InsuranceListUpper(payload);
        if (data.data.Data == null) {
          commit("SET_UPPERS", []);
        } else {
          commit("SET_UPPERS", data.data.Data);
        }
      } catch (err) {
        commit("SET_UPPERS", []);
      }
    },
    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.InsuranceList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    async listAll({ commit, state },payload) {
      try {
        const data = await LmgService.InsuranceListUpper({level:0});
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getUpper(state) {
      return state.uppers;
    },
    getDataWithAll(state) {
      return [{ID:0,Name:"ทั้งหมด"},...state.datas];
    },
    
  }
};

export default InsuranceModule;
